/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Miteigenanteilzurrv3Inputs */



/**

* @param {_Field_Miteigenanteilzurrv3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_miteigenanteilzurrv3 = /** @type {((inputs?: _Field_Miteigenanteilzurrv3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Miteigenanteilzurrv3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Mit Eigenanteil zur RV")
});
export { _field_miteigenanteilzurrv3 as "_field_mitEigenanteilZurRv" }